import { configureStore } from "@reduxjs/toolkit";
import overflowReducer from "./overflowBlockSlice";
import blockClassNameReducer from "./blockClassNameSlice";
import { dataApi } from "../api/dataApi.js";
import { unsplashApi } from "../api/unsplashApi.js";
import scrappingReducer from "./scrappingSlice";
import draftReducer from "./draftSlice";
import videoReducer from "./videoSlice";
import appRouteReducer from "./appRouteSlice";
import buttonReducer from "./buttonSlice";

const store = configureStore({
  reducer: {
    overflow: overflowReducer,
    scrapping: scrappingReducer,
    blockClassName: blockClassNameReducer,
    [dataApi.reducerPath]: dataApi.reducer,
    [unsplashApi.reducerPath]: unsplashApi.reducer,
    draft: draftReducer,
    videos: videoReducer,
    appRoute: appRouteReducer,
    button: buttonReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(dataApi.middleware, unsplashApi.middleware),
});

export default store;
